// src/components/Help.js
import React, { useEffect } from "react";
import Contact from "./Contact";

const Help = () => {
  /* Re-attach the scroll-animation observer so “.animate” items
     fade in every time this page mounts. */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 }
    );

    const targets = document.querySelectorAll(".animate");
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  /* FAQ content in one place for readability */
  const faqs = [
    {
      q: "How do I get started?",
      a: "Simply install the Chrome extension and log in with your Google account."
    },
    {
      q: "Undo or Redo not working properly?",
      a: (
        <>
          Watch this quick alternative fix:&nbsp;
          <a
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#6a0dad", fontWeight: "bold" }}
          >
            Watch on&nbsp;YouTube
          </a>
        </>
      )
    },
    {
      q: "Is ClevSheetsAI free?",
      a: "Yes. Since we’ve just launched, all plans are free for a few months."
    },
    {
      q: "What is the limit?",
      a: "Each plan has a limit on the number of cells you can give as input."
    },
    {
      q: "What is a cell range?",
      a: "It’s the block of cells you select to feed into the AI — the smaller the range, the faster the output."
    },
    {
      q: "What can I give as a prompt?",
      a: "Anything that would normally require manual edits. Example: “Detect duplicate customer complaints in Column D (even if wording is slightly different) and flag duplicates in Column E.”"
    },
    {
      q: "Is there dark mode on the extension?",
      a: "Yes. Click the moon (crescent) icon to toggle dark mode."
    },
    {
      q: "I’m unable to edit my sheet through ClevSheetsAI. What should I do?",
      a: "Make sure you’re logged in with the Google account that owns (or has edit access to) the sheet — that’s the account ClevSheetsAI will use."
    },
    {
      q: "What is the sheet name?",
      a: "It’s the tab label at the bottom-left of Google Sheets; the highlighted one is the sheet you’re currently viewing."
    }
  ];

  return (
    <section id="help" className="contact animate">
      <h2>FAQ</h2>

      <div className="faq-list" style={{ maxWidth: 900, margin: "0 auto" }}>
        {faqs.map(({ q, a }, idx) => (
          <div key={idx} className="faq-item" style={{ marginBottom: "1.5rem" }}>
            <strong style={{ display: "block", marginBottom: 6 }}>{q}</strong>
            <span>{a}</span>
          </div>
        ))}
      </div>

      <p style={{ margin: "2.5rem 0 1rem" }}>
        Still have questions or feedback? Drop us a line:
      </p>

      <Contact />
    </section>
  );
};

export default Help;
